import { Outlet } from 'react-router-dom'
import SidebarNew from '../Sidebar/SidebarNew'
import HeaderBackoffice from '../Header/HeaderBackoffice'
import SucursalGate from '../../../SucursalGate/SucursalGate'
import { useHasRedesign } from '@/utils/redesignSellers'

const BackofficeLayout = () => {
  const hasRedesign = useHasRedesign()

  return (
    <div className='flex flex-col h-screen overflow-hidden' style={{ background: 'linear-gradient(to bottom, #F4F7FD, #BCC8DE)' }}>
      {/* Bloquea el backoffice hasta que el usuario WOM con varias sucursales elija una. */}
      <SucursalGate />
      <HeaderBackoffice />
      <div className='flex flex-1 overflow-hidden'>
        <SidebarNew />
        <div className='flex-1 overflow-y-auto'>
          {/* Rediseño: antes esto vivía centrado dentro de un `container` con max-width por
              breakpoint de VIEWPORT (no del ancho real disponible), así que el espacio que el
              sidebar liberaba al colapsarse quedaba como margen muerto en vez de dárselo al
              contenido. `w-full` hace que ocupe todo el ancho que el sidebar deje libre (más
              angosto con el menú expandido, más ancho colapsado), sin tope artificial.
              Los sellers sin rediseño (ver REDESIGN_SELLERS) siguen con el contenedor centrado. */}
          {hasRedesign
            ? (
              <div className='w-full px-[15px] py-[15px] 4xl:py-[25px]'>
                <Outlet />
              </div>
              )
            : (
              <div className='flex justify-center'>
                <div className='container mx-auto px-[15px] py-[15px] 4xl:py-[25px]'>
                  <Outlet />
                </div>
              </div>
              )}
        </div>
      </div>
    </div>
  )
}

export default BackofficeLayout
